// extracted by mini-css-extract-plugin
export default {"leaderboardModelLink":"Leaderboard_leaderboardModelLink__KN5nW","leaderboardModelContaminated":"Leaderboard_leaderboardModelContaminated__4+ik8"};